import {IErrorHandler} from '@src/@interfaces/services/ErrorHandler/IErrorHandler';
import app from '@src/helpers/app';
import {setFatalError} from '@src/_redux/app/actions';
import AbstractBaseError from '@src/exceptions/AbstractBaseError';
import {IListener} from '@src/@interfaces/services/Events';
import {ISubscription} from '@src/@interfaces/services/Events/ISubscription';

enum ErrorHandlerEvents {
    'ERROR_OCCURRED' = 'error-occurred',
}

export default class ErrorHandler implements IErrorHandler {
    handle(error: Error | string): void {
        if (typeof error === 'string') {
            error = new Error(error);
        }

        this.fireErrorOccurredEvent(error);
        if (error instanceof AbstractBaseError && !error.isShouldBeReported()) {
            return;
        }

        this.report(error);
    }

    display(error: Error): void {
        app().dispatchAction(setFatalError(error));
    }

    report(error: Error | object): void {
        const report = error instanceof Error ? {
            message: error.message,
            error: {
                name: error.name,
                message: error.message,
                stack: error.stack
            }
        } : {
            __is_plain_object: true,
            ...error
        };

        if (console?.error) {
            console.error(report.message ? report.message : report);
        }

        fetch('/api/track-client-error', {
            method: 'post',
            redirect: 'error',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': document
                    ?.querySelector('meta[name="csrf-token"]')
                    ?.getAttribute('content') || '',
            },
            mode: 'cors',
            credentials: 'same-origin',
            body: JSON.stringify({
                ...report,
                context: {
                    appVersion: app('config').get('client.app-version'),
                    browser: window.navigator.userAgent,
                    resolution: [window.innerWidth, window.innerHeight],
                    url: window.location.href,
                },
                user: {
                    id: app('auth').getUser()?.id
                }
            })
        }).then(res => {
            if (res.status === 204) {
                console.info('Error was logged');
            }
        });
    }

    onErrorOccurred(listener: IListener<{ error: Error }>): ISubscription {
        return app('events').listen(ErrorHandlerEvents.ERROR_OCCURRED, listener);
    }

    protected fireErrorOccurredEvent(error: Error): void {
        app('events').dispatch(ErrorHandlerEvents.ERROR_OCCURRED, {error});
    }
}
